import { useEditor, ChildrenBlock } from '@smartfire/js-block-engine';
import { EditableHeading, EditableText } from '@smartfire/components';
import SocialButton from '../../shared/social-button';
import { useMediaQuery } from 'react-responsive';
import clsx from 'clsx';
import style from './style.module.scss';

function Template1({ socials, subtitle, title }) {
    const { isEditing } = useEditor();
    const isMobile = useMediaQuery({ query: '(max-width: ' + style.mobileBreakpoint + ')' });
    const isSocial = socials && (socials.facebookUrl || socials.facebookUrl || socials.youtubeUrl);

    const TEMPLATE = [
        ['smartfire/social-networks---media', {}],
        ['smartfire/social-networks---media', {}],
        ['smartfire/social-networks---media', {}],
        ['smartfire/social-networks---media', {}],
        ['smartfire/social-networks---media', {}],
        ['smartfire/social-networks---media', {}],
    ];

    return (
        <div className={clsx(style.template1, isMobile && style.mobile, isEditing && style.editing)}>
            <div className={style.titles}>
                {(isEditing || subtitle) && (
                    <EditableText
                        tagName={'p'}
                        smartProp={'subtitle'}
                        placeholder={'Sous-titre...'}
                        className={style.subtitle}
                    />
                )}
                {(isEditing || title.content) && (
                    <EditableHeading smartProp={'title'} placeholder={'Titre...'} className={style.title} />
                )}
            </div>
            {isSocial && (
                <div className={style.socials}>
                    {socials.facebookUrl && (
                        <SocialButton socialNetwork={'facebook'} url={socials.facebookUrl} backgroundColor={'blue'} />
                    )}
                    {socials.instagramUrl && (
                        <SocialButton socialNetwork={'instagram'} url={socials.instagramUrl} backgroundColor={'blue'} />
                    )}
                    {socials.youtubeUrl && (
                        <SocialButton socialNetwork={'youtube'} url={socials.youtubeUrl} backgroundColor={'blue'} />
                    )}
                </div>
            )}
            <ChildrenBlock
                key="children"
                gutenbergEditorConfig={{
                    orientation: 'vertical',
                    allowedBlocks: ['smartfire/social-networks---media'],
                    template: TEMPLATE,
                    templateLock: true,
                }}
                className={style.medias}
            />
        </div>
    );
}

export default Template1;
